const CreateSectionTypes = {
  CREATE_SECTION_START: 'CREATE_SECTION_START',
  CREATE_SECTION_SUCCESS: 'CREATE_SECTION_SUCCESS',
  CREATE_SECTION_FAILURE: 'CREATE_SECTION_FAILURE',
  CREATE_SECTION_FINISH: 'CREATE_SECTION_FINISH'
};

export default CreateSectionTypes;
